import escapeHtml from 'lodash/escape';
import type { FunctionComponent } from 'react';

import { useTranslate } from '~/shared/context/use-translate';

import { ContentSections } from '../components/Common';
import { DescriptionDiff } from './DescriptionDiff';

export { TaskContentsComparisonSection } from './TaskContentsComparisonSection';

const taskListHtml = (titles: readonly string[]): string =>
    `<ul>${titles.map((title) => `<li>${escapeHtml(title)}</li>`).join('')}</ul>`;

/** Both sides' task titles as lists, marked like the description sections: removed on the left, added on the right. */
export const TasksComparisonSection: FunctionComponent<{
    readonly left: readonly string[];
    readonly right: readonly string[];
}> = ({ left, right }) => {
    const translate = useTranslate();
    const title = translate('pages.job-architecture-v2.comparision.tasks-section');
    const leftHtml = taskListHtml(left);
    const rightHtml = taskListHtml(right);

    return (
        <ContentSections columns="two">
            <div data-testid="tasks-diff-left">
                <DescriptionDiff against={leftHtml} current={rightHtml} title={title} type="removed" />
            </div>
            <div data-testid="tasks-diff-right">
                <DescriptionDiff against={leftHtml} current={rightHtml} title={title} type="added" />
            </div>
        </ContentSections>
    );
};
